// set new options to specific polyline => it will redraw it
const changePolyline = (polyline, opts) => {
  polyline.setOptions(opts)
}

export default changePolyline
// https://stackoverflow.com/questions/9831830/change-polyline-color-dynamically



// WEBPACK FOOTER //
// ./app/polylines/changePolyline.js